export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./flg-frame.vue?vue&type=template&id=24835a59"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/flg/flg-frame.vue?vue&type=template&id=24835a59
// module id = wCzD
// module chunks = 0